import React from 'react';

import {
  Flex,
  Text,
  Accordion,
  AccordionItem,
  AccordionButton as ChakraAccordionButton,
  AccordionIcon,
  AccordionPanel,
} from '@chakra-ui/react';

import { StatusBadge } from 'components';
import { statusType } from 'constants/badgeTypes';

interface AccordionDeliveryProps{
    title: 'Coleta'|'Entrega'
    status?: keyof typeof statusType
}
function AccordionButton({ title, status } : AccordionDeliveryProps) {
  return (
    <ChakraAccordionButton
      _expanded={{ borderBottom: '1px', borderColor: 'gray.50' }}
      _focus={null}
      p={0}
      pl={7}
      _hover={null}>
      <Flex
        flex="1"
        p={2}
        textAlign="left"
        justify="space-between"
        flexDirection="row">
        <Text
          color="primary.default"
          variant="mediumBold">
          {title}
        </Text>
        <StatusBadge
          label={status.toLocaleUpperCase()}
          iconName="clock"
          status={status}
        />
      </Flex>
      <Flex
        p={2}
        borderLeft="1px"
        borderColor="gray.50">
        <AccordionIcon color="gray.500" />
      </Flex>
    </ChakraAccordionButton>
  );
}

export default function AccordionHeader({
  title,
  status,
  children,
} : any) {
  return (
    <>
      <Accordion
        mb={5}
        bg="white"
        w="800px"
        borderRadius="8px"
        _focus={null}
        allowToggle>
        <AccordionItem borderStyle="hidden">
          <AccordionButton
            title={title}
            status={status}
          />
          <AccordionPanel
            pb={7}
            pt={6}
            px={12}>
            {children}
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </>
  );
}
